
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import React, { useEffect, lazy, Suspense, useState } from "react";

// LAZY IMPORTS

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Sutentdashboard from "./Studentadmin/Header";
import Loader from "./Loader";
import usePageReady from "./usePageReady";

const App = lazy(() => import("./App"));
const HeaderMenuDetails = lazy(() => import("./Header/Menudetailspage"));
// const Header = lazy(() => import("./Header/Header"));
const Subjectdetails = lazy(() => import("./Header/Subjectdetails"));
const UpcommingExamDetailsPage = lazy(() => import("./Pages/Upcommingexamdetails"));
// const Footer = lazy(() => import("./Footer/Footer"));
const Loginpage = lazy(() => import("./Pages/Loginpage"));
const Loginpagedirect = lazy(() => import("./Pages/Loginpagedirect"));
const Otp = lazy(() => import("./Pages/Otppage"));
const Signup = lazy(() => import("./Pages/Signuppage"));

const MediaPressrelies = lazy(() => import("./Pages/blog/Mediapage"));
const Latestnews = lazy(() => import("./Pages/blog/Latestnews"));
const Latestnewsdata = lazy(() => import("./Pages/blog/Newsdetails"));
const Commingsoon = lazy(() => import("./Pages/blog/Commingsoon"));
const Newsdetails = lazy(() => import("./Pages/blog/Newsdetails"));
const Termscondition = lazy(() => import("./Pages/Termcondition"));
const Testseriespage = lazy(() => import("./Pages/testseriespage/Testseriespage"));
const Teacheroncall = lazy(() => import("./Pages/teacheroncall/Teacheroncall"));
const Selectedpaper = lazy(() => import("./Pages/teacheroncall/Selectedpaper"));
const Cartpage = lazy(() => import("./Pages/teacheroncall/Cartpage"));
const Aboutus = lazy(() => import("./Pages/aboutus/AboutUs"));
const Joinourteam = lazy(() => import("./Pages/Joinourteam"));
const Mediadetailspage = lazy(() => import("./Pages/blog/Mediadetailspage"));
const Latestnewsdatalist = lazy(() => import("./Pages/blog/Latestnewsdetails"));
const Currentaffairepage = lazy(() => import("./Pages/blog/Currentaffairpage"));
const Cartsummery = lazy(() => import("./Pages/teacheroncall/Cartsummerypage"));

const Liveclasses = lazy(() => import("./Pages/liveclasses/Liveclassess"));
const Liveclassagorajoin = lazy(() => import("./Studentadmin/student-dashboard/Liveclassagora"));
const Liveinterviewagorajoin = lazy(() => import("./Studentadmin/interview/Liveinterviewagora"));

// const Sutentdashboard = lazy(() => import("./Studentadmin/Header"));
const DemoBooking = lazy(() => import("./Pages/demo-booking/Demobooking"));
const Liveinterview = lazy(() => import("./Pages/live-interview/Live-interview"));
const Liveinterviewpackage = lazy(() => import("./Pages/teacheroncall/Liveinterviewpackage"));
const StudentProfile = lazy(() => import("./Studentadmin/profile/Profile"));
const DashBoard = lazy(() => import("./Studentadmin/student-dashboard/Dashboard"));
const Wallet = lazy(() => import("./Studentadmin/wallet/Wallet"));
const MyReferral = lazy(() => import("./Studentadmin/wallet/MyReferral"));

const Helpsupport = lazy(() => import("./Studentadmin/Helpsupport"));
const Helpsupportchat = lazy(() => import("./Studentadmin/Helpsupportchat"));
const Packagedetails = lazy(() => import("./Studentadmin/Packagedetails"));
const Testpaper = lazy(() => import("./Studentadmin/Testpaper"));
const Testresults = lazy(() => import("./Studentadmin/Testresults"));
const Studentprogressreport = lazy(() => import("./Studentadmin/Studentprogressreport"));
const TestseriesAdmin = lazy(() => import("./Studentadmin/Testseriesadmin"));
const PackagedetailsTeacheroncall = lazy(() => import("./Studentadmin/Packagedetailteacheroncall/Packagedetails"));
const CallhistoryTeacheroncall = lazy(() => import("./Studentadmin/Packagedetailteacheroncall/Callhistory"));
const Notes = lazy(() => import("./Studentadmin/Notes"));
const Notification = lazy(() => import("./Studentadmin/Notification"));

const PackagedetailsInterview = lazy(() => import("./Studentadmin/interview/Packagedetails"));
const Interviewhistory = lazy(() => import("./Studentadmin/interview/Interviewhistory"));
const Myinterview = lazy(() => import("./Studentadmin/interview/Myinterview"));
const Manageschedule = lazy(() => import("./Studentadmin/interview/Manageschedule"));
const Liveclass = lazy(() => import("./Studentadmin/Liveclass/Liveclass"));
const Callhistory = lazy(() => import("./Studentadmin/Liveclass/Previuscallhistory"));
const Packagedetailsliveclass = lazy(() => import("./Studentadmin/Liveclass/Packagedetails"));
const Managescheduleliveclass = lazy(() => import("./Studentadmin/Liveclass/Manageschedule"));

const StartTest = lazy(() => import("./Studentadmin/teststart/Starttest"));
const BegingTest = lazy(() => import("./Studentadmin/teststart/Begingtest"));
const Myorder = lazy(() => import("./Studentadmin/teststart/Myorder"));
const Orderdetails = lazy(() => import("./Studentadmin/teststart/Orderdetails")); 
const TeacherOrderdetails = lazy(() => import("./Studentadmin/teststart/Teacheroncallorderdetails"));
const Exam = lazy(() => import("./Testingwindow"));
const Thankupage = lazy(() => import("./Thankupage"));
const SelectedpaperBuy = lazy(() => import("./Pages/teacheroncall/Selectedpaperbuy"));
const Teacheroncallsummery = lazy(() => import("./Pages/teacheroncall/Selectedpapersummerypage"));
const Teacheroncallteacherlist = lazy(() => import("./Studentadmin/Packagedetailteacheroncall/Teacherlist"));
const SelectedLiveclass = lazy(() => import("./Pages/liveclasses/Selectedliveclass"));
const Privacypolicy = lazy(() => import("./Pages/PrivacyPolicy"));
const Liveclassescheckoutpage = lazy(() => import("./Pages/liveclasses/Liveclassescheckoutpage"));
const Liveclassschedule = lazy(() => import("./Studentadmin/Liveclass/Liveclassesteacher"));
const TestsubmitThankupage = lazy(() => import("./Studentadmin/teststart/thankupage"));
const Viewsolution = lazy(() => import("./Studentadmin/teststart/Viewsolution"));
const Upcommingexamlist = lazy(() => import("./Homepage/Upcommingexam"));
const Refers = lazy(() => import("./Homepage/Referearn"));
const Cookies = lazy(() => import("./Pages/Cookies"));
const Resources = lazy(() => import("./Pages/teacheroncall/Resources"));
const Previousyear = lazy(() => import("./Homepage/Previousyearpaper"));
const Resourcespdfdetails = lazy(() => import("./Pages/teacheroncall/Resoursespdflist"));
const Agora = lazy(() => import("./Agoratesting"));
const Livejoin = lazy(() => import("./Studentadmin/Packagedetailteacheroncall/Livepage"));
const ParentComponent = lazy(() => import("./Agoratesting"));
const Teachercallhistory = lazy(() => import("./Studentadmin/Packagedetailteacheroncall/Teachercallhistory"));
const ResourcespdfdetailsLink = lazy(() => import("./Pages/teacheroncall/Resourcepdflinkdetails"));
const Liveinterviewoackagebuy = lazy(() => import("./Pages/teacheroncall/Liveinterviewpackagebuy"));
const Interviewlist = lazy(() => import("./Studentadmin/interview/Interviewschedulelist"));
const Liveclassjoin = lazy(() => import("./Studentadmin/Liveclass/Joinpage"));
const InterviewJoin = lazy(() => import("./Studentadmin/interview/Interviewjoin"));
const Previousyearpaperlist = lazy(() => import("./Homepage/Previousyearpaperlist"));
const Thankupagerazorpay = lazy(() => import("./Pages/teacheroncall/Thankupage"));
const Upcommingexamdetails = lazy(() => import("./Homepage/Upcommingexamdetails"));
const Upcommingexamdetailsnational = lazy(() => import("./Homepage/Upcommingexamdetailsnational"));
const Currentaffairdetails = lazy(() => import("./Pages/blog/Currentaffairedetail"));
const Getcallback = lazy(() => import("./Pages/demo-booking/Getcallback"));
const Studentsharefeedback = lazy(() => import("./Pages/demo-booking/Studentsharefeedback"));
const Teachersharefeedback = lazy(() => import("./Pages/demo-booking/Teachersharefeedback"));
const Teacherbenifit = lazy(() => import("./Pages/demo-booking/Teacherbenifit"));
const Studentcontact = lazy(() => import("./Pages/demo-booking/Studentscontact"));
const Teacherregistration = lazy(() => import("./Pages/demo-booking/Teacherregister"));
const TeacherLists = lazy(() => import("./Teacheroncallupdate/Teacherlist"));
const TestseriesSubjectdetails = lazy(() => import("./Header/Testseriespackagedetails"));
const Exacomissionpage = lazy(() => import("./Pages/Examinationcommissionpage"));
const Subscription = lazy(() => import("./Studentadmin/Subscriptionpage"));
const Subscriptioninvoice = lazy(() => import("./Studentadmin/Subscriptioninvoice"));
const Comissionpage = lazy(() => import("./Header/Comissionpage"));
const Faq = lazy(() => import("./Homepage/Faq"));
const Companyaboutus = lazy(() => import("./Homepage/Companyaboutus"));
const OurTeam = lazy(() => import("./Homepage/Ourteam"));
const Whyus = lazy(() => import("./Homepage/Whyus"));
const Disclaimer = lazy(() => import("./Pages/Disclaimer"));
const Refundcancel = lazy(() => import("./Pages/Refundcancelation"));
const Reportsabouse = lazy(() => import("./Pages/demo-booking/Reportabouse"));
const Classroom = lazy(() => import("./Pages/demo-booking/Classroom"));
const Helpsupporthomepage = lazy(() => import("./Homepage/Helpsupport"));
const Helpsupportteacher = lazy(() => import("./Homepage/Helpsupportteacher"));
const Faqteacher = lazy(() => import("./Homepage/Faqteacher"));
const Freemokup = lazy(() => import("./Pages/demo-booking/Freemockuptest"));
const Freemockuppage = lazy(() => import("./freemockup/Freemockuppage"));
const Liveclassespackage = lazy(() => import("./Pages/liveclasses/Liveclassespackage"));
const Liveclassespackagedetails = lazy(() => import("./Pages/liveclasses/detialspagelivepackage"));
const Servicespage = lazy(() => import("./Header/ServicePage"));
const Examinations = lazy(() => import("./Header/Categoryexam"));
const ViewNotes = lazy(() => import("./Studentadmin/Viewnotes"));
const ScheduleCalender = lazy(() => import("./Studentadmin/student-dashboard/Schedulecalender"));
const ScheduleCalenderclass = lazy(() => import("./Studentadmin/student-dashboard/Scheduleclass"));
const Livetestquizlist = lazy(() => import("./Homepage/Livetestquizlist"));
const ViewScheduleCalenderclass = lazy(() => import("./Studentadmin/student-dashboard/Liveclassviewschedule"));
const TeacheroncallThankupage = lazy(() => import("./Pages/teacheroncall/Teacheroncallthankupage"));
const Teacheroncallmeeting = lazy(() => import("./Pages/teacheroncall/Teacheroncallmeetingpage"));
const Allfeedback = lazy(() => import("./Studentadmin/Feedbackallreview"));
const Quizstart = lazy(() => import("./Homepage/Livequizquestion"));
const TeacheroncallsummeryExtra = lazy(() => import("./Pages/teacheroncall/Extraaddonmin"));
const Quiz = lazy(() => import("./Testingwindow"));
const Quiztest = lazy(() => import("./Updatetestingpaper"));
const Quizadmin = lazy(() => import("./Studentadmin/student-dashboard/Quiz"));
const Resultsummery = lazy(() => import("./Studentadmin/student-dashboard/Summery"));
const Interviewdetails = lazy(() => import("./Pages/teacheroncall/Liveinterviewdetails"));


function NavbarConditional() {
  const location = useLocation();
  const hideNavbarRoutes = [
    "/student-admin",
   "/student-profile",
   "/wallet",
   "/My-Referral",
   "/help-support",
   "/package-details",
   "/package-test-series",
   "/test-paper",
   "/test-results",
   "/student-progress-report",
   "/teacheroncall/package-details",
   "/teacheroncall/call-history",
   "/notes",
   "/notification",
   "/interview-package-details",
   "/interview-history",
   "/my-interview",
   "/manage-sechedule",
   "/live-class",
   "/call-history",
   "/live-classes-package-details",
   "/live-class-manage-schedule",
   "/start-test",
   "/start-test/[^/]+$",
   "/orderdetail/[^/]+$",
   "/help-support-details/[^/]+$",
   "/teacher-on-call-orderdetail/[^/]+$",
   "/result-summery/[^/]+$",
   "/subscription-invoice/[^/]+$",
   "/teacheroncall/teacher-selection/[^/]+$",
   "/live-classes/class-selection/[^/]+$",
   "/interview-list/[^/]+$",
  //  "/test-submitted/[^/]+$",
  //  "/view-solution/[^/]+$",
  //  "/selected-live-classes/[^/]+$",
   "/orders",
   "/quiz",
   "/live-classes-join/[^/]+$/[^/]+$",
   "/interview-join/[^/]+$/[^/]+$",
   "/subscription",
   "/view-note/[^/]+$",
   "/schedule-meeting/[^/]+$",
    "/schedule-class/[^/]+$",
    "/view-schedule/[^/]+$",
    "/feedback",
    "/paper-start",
    "/paper-start-type2"
  //  "/subscription-invoice/[^/]+$/[^/]+$"
    
  ];

  // Function to determine whether to show Navbar based on the current route
  const shouldShowNavbar = () => {
    return !hideNavbarRoutes.some((route) =>
    new RegExp(`^${route}(\/|$)`).test(location.pathname)
  );
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [location]);

  return shouldShowNavbar() ? <Header /> : null;
  
}
function FooterConditional() {
  const location = useLocation();
  const hideNavbarRoutes = [
    "/student-admin",
    "/student-profile",
    "/wallet",
    "/My-Referral",
    "/help-support",
    "/package-details",
    "/package-test-series",
    "/test-paper","/test-results",
    "/student-progress-report",
    "/teacheroncall/package-details",
    "/teacheroncall/call-history",
    "/notes",
    "/notification",
    "/interview-package-details",
    "/interview-history",
    "/my-interview",
    "/manage-sechedule",
    "/live-class",
    "/call-history",
    "/live-classes-package-details",
    "/live-class-manage-schedule",
    "/start-test",
    "/start-test/[^/]+$",
    "/result-summery/[^/]+$",
    "/orderdetail/[^/]+$",
    "/teacher-on-call-orderdetail/[^/]+$",
    "/subscription-invoice/[^/]+$",
    "/teacheroncall/teacher-selection/[^/]+$",
    "/live-classes/class-selection/[^/]+$",
    "/interview-list/[^/]+$",
    // "/test-submitted/[^/]+$",
    // "/view-solution/[^/]+$",
    "/orders",
    "/quiz",
    "/live-classes-join/[^/]+$/[^/]+$",
    "/interview-join/[^/]+$/[^/]+$",
    "/help-support-details/[^/]+$",
    "/subscription",
    "/view-note/[^/]+$",
    "/schedule-meeting/[^/]+$",
    "/schedule-class/[^/]+$",
    "/view-schedule/[^/]+$",
    "/feedback",
    "/paper-start",
    "/paper-start-type2"
    // "/subscription-invoice/[^/]+$/[^/]+$"
    // "/thank-you/:id"
  ];

  // Function to determine whether to show Navbar based on the current route
  const shouldShowNavbar = () => {
    return !hideNavbarRoutes.some((route) =>
    new RegExp(`^${route}(\/|$)`).test(location.pathname)
  );
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [location]);

  return shouldShowNavbar() ? <Footer /> : <Sutentdashboard/>;
 
}

export default function RouterPage() {
  // useEffect(() => {

  //   const disableContextMenu = e => e.preventDefault();
  //   const disableCopy = e => e.preventDefault();

  //   const disableKeys = e => {

  //     // Ctrl based shortcuts
  //     if (e.ctrlKey) {
  //       const blocked = ["c", "v", "x", "u", "s", "p"];
  //       if (blocked.includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //       }
  //     }

  //     // F12
  //     if (e.key === "F12") {
  //       e.preventDefault();
  //     }

  //     // Ctrl + Shift + I / J / C
  //     if (e.ctrlKey && e.shiftKey) {
  //       const blockedShift = ["i", "j", "c"];
  //       if (blockedShift.includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //       }
  //     }
  //   };

  //   document.addEventListener("contextmenu", disableContextMenu);
  //   document.addEventListener("copy", disableCopy);
  //   document.addEventListener("cut", disableCopy);
  //   document.addEventListener("paste", disableCopy);
  //   document.addEventListener("keydown", disableKeys);

  //   return () => {
  //     document.removeEventListener("contextmenu", disableContextMenu);
  //     document.removeEventListener("copy", disableCopy);
  //     document.removeEventListener("cut", disableCopy);
  //     document.removeEventListener("paste", disableCopy);
  //     document.removeEventListener("keydown", disableKeys);
  //   };
  // }, []);


  const [apiLoaded, setApiLoaded] = useState(false);

  // EXAMPLE API CALL
  useEffect(() => {
    fetch("https://jsonplaceholder.typicode.com/posts")
      .then(r => r.json())
      .then(() => setApiLoaded(true));
  }, []);

  // Page ready check — 5 sec + images + API
  const ready = usePageReady(apiLoaded);

  if (!ready) return <Loader />;


  return (
    <BrowserRouter>
    <Suspense fallback={<Loader />}>
      <NavbarConditional />
     
      <Routes>
    
        <Route path="/" element={<App />}>
        </Route>
        <Route path="/view-schedule/:slug" element={<ViewScheduleCalenderclass />}/>
        <Route path="/quiz-list" element={<Livetestquizlist />}/>
        <Route path="/quiz-start/:slug" element={<Quizstart />}/>
        <Route path="/paper-start" element={<Quiztest />}/>
        <Route path="/paper-start-type2" element={<Quiz/>}/>
        <Route path="/schedule-class/:slug" element={<ScheduleCalenderclass />}/>
        <Route path="/schedule-meeting/:slug" element={<ScheduleCalender />}/>
        <Route path="/view-note/:id" element={<ViewNotes />}/>
        <Route path="/login" element={<Loginpage />}/>
        <Route path="/log-in" element={<Loginpagedirect />}/>
        <Route path="/blogs" element={<Latestnews />}/>
         <Route path="/latest-news" element={<Latestnewsdata />}/>
        <Route path="/comming-soon" element={<Commingsoon />}/>
        <Route path="/news-details" element={<Newsdetails />}/>
        <Route path="/test-series-package-details/:title/:slug/:id/:testid" element={<TestseriesSubjectdetails />}/>
        <Route path="/blog-details/:name" element={<Mediadetailspage />}/>
        <Route path="/new-details/:name" element={<Latestnewsdatalist />}/>
        <Route path="/current-affairs" element={<Currentaffairepage />}/>
        <Route path="/current-affairs-details/:id" element={<Currentaffairdetails />}/>
        <Route path="/verify-otp" element={<Otp />}/>
        <Route path="/signup" element={<Signup />}/>
        <Route path="/media-page" element={<MediaPressrelies/>}/>
        <Route path="/terms-condition" element={<Termscondition/>}/>
        <Route path="/privacy-policy" element={<Privacypolicy/>}/>
        <Route path="/exam-category/:name" element={<HeaderMenuDetails />}/>
        <Route path="/teacher-on-call/teacher-list/:name" element={<TeacherLists />}/>
        <Route path="/subject-details/:title" element={<Subjectdetails />}/>
        <Route path="/upcomming-exam-details/:name" element={<UpcommingExamDetailsPage />}/>
        <Route path="/test-series-page" element={<Testseriespage />}/>
        <Route path="/teacher-on-call" element={<Teacheroncall />}/>
        <Route path="/live-classes-checkout/:slug/:id" element={<Liveclassescheckoutpage />}/>
        <Route path="/selected-paper/:id" element={<Selectedpaper />}/>
        <Route path="/resources-details/:id" element={<Resourcespdfdetails />}/>
        <Route path="/resources-details-data/:mode/:id" element={<ResourcespdfdetailsLink />}/>
        <Route path="/selected-live-classes/:name/:id" element={<SelectedLiveclass />}/>
        <Route path="/extra-min/:id/:min/:method" element={<TeacheroncallsummeryExtra />}/>
         <Route path="/selected-paper-buy-now/:id" element={<Teacheroncallsummery />}/>
         <Route path="/selected-live-interview-buy-now/:id" element={<Liveinterviewoackagebuy />}/>
        
        <Route path="/cart" element={<Cartpage />}/>
        <Route path="/cart-summery" element={<Cartsummery />}/>
        <Route path="/about-us" element={<Aboutus />}/>
        <Route path="/career" element={<Joinourteam />}/>
        <Route path="/live-classes" element={<Liveclasses />}/>
        <Route path="/live-classes-join/:id/:orderid" element={<Liveclassjoin />}/>
        <Route path="/interview-join/:id/:orderid" element={<InterviewJoin />}/>
        <Route path="/student-admin" element={<DashBoard />}/>
        <Route path="/demo-booking" element={<DemoBooking />}/>
        <Route path="/get-callback" element={<Getcallback />}/>
        <Route path="/contact-us" element={<Studentcontact />}/>
        <Route path="/teacher-registration" element={<Teacherregistration />}/>
        <Route path="/student-share-feedback" element={<Studentsharefeedback />}/>
        <Route path="/teacher-share-feedback" element={<Teachersharefeedback />}/>
        <Route path="/teacher-benefits" element={<Teacherbenifit />}/>
        <Route path="/live-interview" element={<Liveinterview />}/>
        <Route path="/student-profile" element={<StudentProfile />}/>
        <Route path="/live-interview-package/:id" element={<Liveinterviewpackage />}/>
        <Route path="/wallet" element={<Wallet />}/>
        <Route path="/My-Referral" element={<MyReferral />}/>
        <Route path="/feedback" element={<Allfeedback />}/>
        <Route path="/help-support" element={<Helpsupport />}/>
        <Route path="/help-support-details/:id" element={<Helpsupportchat />}/>
        <Route path="/package-details/:id" element={<Packagedetails />}/>
        <Route path="/package-test-series" element={<TestseriesAdmin />}/>
        <Route path="/test-paper" element={<Testpaper />}/>
        <Route path="/test-results" element={<Testresults />}/>
        <Route path="/student-progress-report" element={<Studentprogressreport />}/>
        <Route path="/teacheroncall/package-details" element={<PackagedetailsTeacheroncall/>}/>
        <Route path="/teacheroncall/call-history/:id" element={<Teachercallhistory/>}/>
        <Route path="/teacheroncall/teacher-selection/:id" element={<Teacheroncallteacherlist/>}/>
        <Route path="/startVideoCall/:id/:tid" element={<Livejoin/>}/>
         <Route path="/startliveclassCall/:id/:sid" element={<Liveclassagorajoin/>}/>
         <Route path="/start-live-interview/:id/:sid" element={<Liveinterviewagorajoin/>}/>
        <Route path="/live-classes/class-selection/:id" element={<Liveclassschedule/>}/>
        <Route path="/teacheroncall/call-history" element={<CallhistoryTeacheroncall/>}/>
        <Route path="/notes" element={<Notes/>}/>
        <Route path="/notification" element={<Notification/>}/>
        <Route path="/interview-package-details" element={<PackagedetailsInterview/>}/>
        <Route path="/interview-history" element={<Interviewhistory/>}/>
        <Route path="/my-interview" element={<Myinterview/>}/>
        <Route path="/manage-sechedule" element={<Manageschedule/>}/>
        <Route path="/live-class" element={<Liveclass/>}/>
        <Route path="/call-history" element={<Callhistory/>}/>
        <Route path="/live-classes-package-details" element={<Packagedetailsliveclass/>}/>
        <Route path="/live-class-manage-schedule" element={<Managescheduleliveclass/>}/>
        <Route path="/start-test" element={<StartTest/>}/>
        <Route path="/orders" element={<Myorder/>}/>
        <Route path="/quiz" element={<Quizadmin/>}/>
        <Route path="/result-summery/:id" element={<Resultsummery/>}/>
        <Route path="/start-test/:id" element={<BegingTest/>}/>
        <Route path="/orderdetail/:id" element={<Orderdetails/>}/>
        <Route path="/teacher-on-call-orderdetail/:id" element={<TeacherOrderdetails/>}/>
        <Route path="/thank-you/:id/:pid" element={<Thankupage/>}/>
        <Route path="/success/:id" element={<TeacheroncallThankupage/>}/>
        <Route path="/connect-now/:id" element={<Teacheroncallmeeting/>}/>
        <Route path="/test-submitted/:id" element={<TestsubmitThankupage/>}/>
        <Route path="/view-solution/:id" element={<Viewsolution/>}/>
        <Route path="/upcomming-exam" element={<Upcommingexamlist/>}/>
        <Route path="/refers-&-earns" element={<Refers/>}/>
        <Route path="/faq" element={<Faq/>}/>
        <Route path="/faq-teacher" element={<Faqteacher/>}/>
        <Route path="/cookies" element={<Cookies/>}/>
        <Route path="/resources" element={<Resources/>}/>
        <Route path="/previous-year-paper" element={<Previousyear/>}/>
        <Route path="/agora" element={<ParentComponent/>}/>
        <Route path="/interview-list/:id" element={<Interviewlist/>}/>
        <Route path="/previous-year-paper-list/:name" element={<Previousyearpaperlist/>} />
        <Route path="/thank-you/:orderid/:id" element={<Thankupagerazorpay/>} />
        <Route path="/upcomming-exam-details-page/:id" element={<Upcommingexamdetails/>} />
        <Route path="/upcomming-exam-details-pages/:id" element={<Upcommingexamdetailsnational/>} />
        <Route path="/exam-comission" element={<Exacomissionpage/>} />
        <Route path="/subscription" element={<Subscription/>} />
        <Route path="/subscription-invoice/:id" element={<Subscriptioninvoice/>} />
        <Route path="/:id" element={<Comissionpage/>}></Route>
        <Route path="/company-aboutus" element={<Companyaboutus/>}></Route>
        <Route path="/our-team" element={<OurTeam/>}></Route>
        <Route path="/why-us" element={<Whyus/>}></Route>
        <Route path="/disclaimer" element={<Disclaimer/>}></Route>
        <Route path="/refunds-and-cancellations" element={<Refundcancel/>}></Route>
        <Route path="/report-an-abuse" element={<Reportsabouse/>}></Route>
        <Route path="/classroom" element={<Classroom/>}></Route>
        <Route path="/help-supports" element={<Helpsupporthomepage/>}></Route>
        <Route path="/help-supports-teacher" element={<Helpsupportteacher/>}></Route>
        <Route path="/mockup-test/:name" element={<Freemokup/>}></Route>
        <Route path="/free-mockup-page" element={<Freemockuppage/>}></Route>
        <Route path="/live-classes-package/:slug" element={<Liveclassespackage/>}></Route>
        <Route path="/live-classes-packages-details/:slug" element={<Liveclassespackagedetails/>}></Route>
        <Route path="/service" element={<Servicespage/>}> </Route>
        <Route path="/examinations" element={<Examinations/>}> </Route>
        <Route path="/live-interview-packages-details/:slug" element={<Interviewdetails/>}> </Route>

        
      </Routes>
     
      <FooterConditional/>
      </Suspense>
    </BrowserRouter>
  );
} 


